import { render, staticRenderFns } from "./paperPreview.vue?vue&type=template&id=7b7f1b66&"
import script from "./paperPreview.vue?vue&type=script&lang=ts&"
export * from "./paperPreview.vue?vue&type=script&lang=ts&"
import style0 from "./paperPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports